import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { take } from "rxjs/operators";
import { DialogUtilsService } from "../dialog-utils/dialog-utils.service";

/**
 * Servicio general que encapsula el envio de mensajes al usuario
 * por parte del resto de componentes de la aplicacion
 *
 * Se encapsula para poder desacoplar los mensajes de confirmacion y
 * error de un componente especifico y que pueda cambiarse de forma global
 * rapidamente
 */
@Injectable({
  providedIn: "root",
})
export class MensajeriaUsuarioService {
  constructor(
    private matSnackbar: MatSnackBar,
    private translateService: TranslateService,
    private dialogService: DialogUtilsService
  ) {}

  private readonly duracionNotificacion = 5000;

  notificarExito(mensaje: string, callback?: Function, panelClass?: string) {
    this.dialogService.abrirSuccess({
      mensaje: mensaje,
      success: callback,
      panelClass: panelClass
    });
  }

  notificarError(mensaje: string, callback?: Function) {
    this.dialogService.abrirError({
      mensaje: mensaje,
      panelClass: 'new_style'
    });
  }

  private mostrarSnackbar(
    mensaje: string,
    callback: Function,
    estilos: string[]
  ) {
    this.translateService
      .get("ACCEPT")
      .pipe(take(1))
      .subscribe((textoAceptar) => {
        const snackBarRef = this.matSnackbar.open(mensaje, textoAceptar, {
          panelClass: estilos,
        });
        snackBarRef
          .afterDismissed()
          .pipe(take(1))
          .subscribe(() => {
            if (callback) {
              callback();
            }
          });
      });
  }
}
